/*
    Add here your own custom javascript
*/
$(document).ready(function () {
    $('.collection-slider').slick({
        infinite: true,
        slidesToShow: 2,
		prevArrow: $('.nav-collection .prev'),
		nextArrow: $('.nav-collection .next'),
		responsive: [
			{
				breakpoint: 765,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
    });
    
    $('.slider').slick({
		infinite: false,
		slidesToShow: 4,
		slidesToScroll: 1,
		prevArrow: $('.nav-slider .prev'),
		nextArrow: $('.nav-slider .next'),
		responsive: [
			{
				breakpoint: 765,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			}
		]
	});

	$('.image-product-link').click( function() {
		const image = $(this).data('image'),
		title = $(this).data('title'),
		description = $(this).data('image');
	});
});